import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { IGroup } from "../interfaces";
import CoreComponent from "./CoreComponent";
import { connect } from "react-redux";
import config from "../config";
import Axios, { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { arrayToFormData } from "../utils/functions";

interface ISimpleHolder { user_id: number, full_name: string };

interface IState {
    group: IGroup,
    isLoading: boolean,
    isHoldersLoading: boolean,
    isModersLoading: boolean,
    inputs: IInputs,
    errors: IInputs,
    holders: ISimpleHolder[],
    moderators: ISimpleHolder[],
    selectedHolders: number[],
    selectedHoldersToRemove: number[],
    search: string,
    searchAdded: string
}

interface IInputs {
    name: string,
    holders_ids: number[],
    moderators_ids: number[],
    [key: string]: any
};

class SingleGroup extends CoreComponent<any, IState> {
    state: IState = {
        group: null,
        isLoading: !!this.props.match.params.id,
        isHoldersLoading: true,
        isModersLoading: true,
        inputs: {
            name: "",
            holders_ids: [],
            moderators_ids: [],
        },
        errors: {
            name: "",
            holders_ids: [],
            moderators_ids: [],
        },
        holders: [],
        moderators: [],
        selectedHolders: [],
        selectedHoldersToRemove: [],
        search: "",
        searchAdded: ""
    }

    async componentWillMount() {
        if (this.props.match.params.id)
            this.loadGroup();

        let response: AxiosResponse = await Axios.get(`${config.api}/user/list`);

        if (!this.isUnmounted) {
            this.setState({
                holders: response.data,
                isHoldersLoading: false
            });
        }

        let res: AxiosResponse = await Axios.get(`${config.api}/user/moderators`);

        if (!this.isUnmounted) {
            this.setState({
                moderators: res.data,
                isModersLoading: false
            });
        }
    }

    async loadGroup() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;

            url = `${config.api}/group/get?id=${this.props.match.params.id}`;

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    group: res.data.model,
                    isLoading: false,
                    inputs: {
                        ...this.state.inputs,
                        name: res.data.model?.name,
                        holders_ids: res.data.holders_ids,
                        moderators_ids: res.data.moderators_ids
                    }
                });
            }
        });
    }

    add() {
        if (this.state.selectedHolders.length > 0) {
            this.setState({
                inputs: {
                    ...this.state.inputs,
                    holders_ids: [...this.state.inputs.holders_ids, ...this.state.selectedHolders]
                },
                selectedHolders: [],
                searchAdded: "",
                search: "",
            })
        } else {
            toast("Выберите правообладателей слева", { type: "error" });
        }
    }

    remove() {
        if (this.state.selectedHoldersToRemove.length > 0) {
            this.setState({
                inputs: {
                    ...this.state.inputs,
                    holders_ids: this.state.inputs.holders_ids.filter((id: number) => !this.state.selectedHoldersToRemove.includes(id))
                },
                selectedHoldersToRemove: [],
                searchAdded: "",
                search: "",
            })
        } else {
            toast("Выберите правообладателей справа", { type: "error" });
        }
    }

    async handleSubmit() {
        let hasError = false;

        if (this.state.inputs.name == "") {
            toast("Заполните названию группы", { type: "error" });
            hasError = true;
        }

        if (this.state.inputs.holders_ids.length == 0) {
            toast("Добавьте правообладателей", { type: "error" });
            hasError = true;
        }

        if (this.state.inputs.moderators_ids.length == 0) {
            toast("Укажите модераторов", { type: "error" });
            hasError = true;
        }

        if (!hasError) {
            this.setState({
                isLoading: true
            }, async () => {
                let response: AxiosResponse = await Axios.post(`${config.api}/group/save${this.props.match.params.id ? ("?id=" + this.props.match.params.id) : ""}`, arrayToFormData(this.state.inputs));

                if (response.data.status == "success") {
                    toast("Данные успешно сохранены", { type: "success" });
                    this.props.history.push("/admin/groups");
                } else {
                    toast(response.data.message, { type: 'error' });
                    this.setState({
                        isLoading: false
                    })
                }
            })
        }
    }

    async delete() {
        if (confirm("Вы уверены?")) {
            let response: AxiosResponse = await Axios.post(`${config.api}/group/delete`, arrayToFormData({ id: this.props.match.params.id }));

            if (response.data.status == "success") {
                toast("Группа удалена.", { type: "success" });
                this.props.history.push("/admin/groups");
            } else {
                toast(response.data.message, { type: "error" });
            }
        }
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-holders">
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin/groups">
                        Назад
                    </NavLink>

                    <span className="crm-holders__title">Группы {this.state.group && (" —— " + this.state.group.name)}</span>

                    <div className="naming">
                        Название:
                        <input type="text" name="name" value={this.state.inputs.name} onChange={(e: any) => {
                            this.setState({
                                inputs: {
                                    ...this.state.inputs,
                                    name: e.target.value
                                }
                            });
                        }} autoComplete="off" />
                    </div>

                    <div className="single-group">
                        <div className="single-group__items">
                            <div className="single-group__item">
                                <ul>
                                    <li>
                                        <input type="checkbox" onChange={() => {
                                            if (this.state.selectedHolders.length != this.state.holders.length) {
                                                this.setState({
                                                    selectedHolders: this.state.holders.map((holder: ISimpleHolder) => holder.user_id)
                                                })
                                            } else {
                                                this.setState({
                                                    selectedHolders: []
                                                })
                                            }
                                        }} checked={this.state.selectedHolders.length == this.state.holders.length} />
                                        Правообладатели
                                        <img src="img/Group 199.svg" />
                                    </li>
                                    <li style={{ position: "relative" }}>
                                        <input type="text" placeholder="Поиск ..." autoComplete="off" name="search" value={this.state.search} onChange={(e) => {
                                            this.setState({
                                                search: e.target.value
                                            });
                                        }} />
                                        <img
                                            style={{ position: "absolute", right: "6%" }}
                                            src="img/Group 232.svg"
                                            alt=""
                                        />
                                    </li>
                                    {this.state.isHoldersLoading && <li>Загрузка...</li>}
                                    {this.state.holders.filter((holder: ISimpleHolder) => !this.state.inputs.holders_ids.includes(holder.user_id)).filter((holder: ISimpleHolder) => this.state.search == "" || holder.full_name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1).map((holder: ISimpleHolder, i: number) => {
                                        return <li key={i}>
                                            <input type="checkbox" checked={!!this.state.selectedHolders.find((id: number) => id == holder.user_id)} onChange={(e: any) => {
                                                if (e.target.checked) {
                                                    this.setState({
                                                        selectedHolders: [...this.state.selectedHolders, holder.user_id]
                                                    });
                                                } else {
                                                    this.setState({
                                                        selectedHolders: this.state.selectedHolders.filter((id: number) => id != holder.user_id)
                                                    });
                                                }
                                            }} />
                                            {holder.full_name}
                                        </li>
                                    })}

                                </ul>
                            </div>
                            <div className="single-group__item">
                                <div className="crm-buttons">
                                    <a
                                        role="button" onClick={() => {
                                            this.add();
                                        }}
                                        className="crm-add"
                                        style={{ marginBottom: "25px" }}
                                    >
                                        {" "}
                                        Добавить
                                        <img src="img/Icon material-keyboard-arrow-down.png" />
                                    </a>
                                    <a role="button" onClick={() => {
                                        this.remove();
                                    }} className="crm-del">
                                        <img src="img/Icon material-keyboard-arrow-up.png" />{" "}
                                        Удалить
                                    </a>
                                </div>
                            </div>
                            <div className="single-group__item">
                                <ul>
                                    <li>
                                        <input type="checkbox" onChange={() => {
                                            if (this.state.selectedHoldersToRemove.length != this.state.inputs.holders_ids.length) {
                                                this.setState({
                                                    selectedHoldersToRemove: this.state.inputs.holders_ids.map((id: number) => id)
                                                })
                                            } else {
                                                this.setState({
                                                    selectedHoldersToRemove: []
                                                })
                                            }
                                        }} checked={this.state.selectedHoldersToRemove.length == this.state.inputs.holders_ids.length} />
                                        {this.state.group?.name}
                                        <img src="img/Group 199.svg" />
                                    </li>
                                    <li style={{ position: "relative" }}>
                                        <input type="text" placeholder="Поиск ..." autoComplete="off" name="searchAdded" value={this.state.searchAdded} onChange={(e) => {
                                            this.setState({
                                                searchAdded: e.target.value
                                            });
                                        }} />
                                        <img
                                            style={{ position: "absolute", right: "6%" }}
                                            src="img/Group 232.svg"
                                            alt=""
                                        />
                                    </li>
                                    {this.state.holders.filter((holder: ISimpleHolder) => this.state.inputs.holders_ids.includes(holder.user_id)).length == 0 && <li className="text-center">
                                        {"Пусто"}
                                    </li>}
                                    {this.state.holders.filter((holder: ISimpleHolder) => this.state.inputs.holders_ids.includes(holder.user_id)).filter((holder: ISimpleHolder) => this.state.searchAdded == "" || holder.full_name.toLowerCase().indexOf(this.state.searchAdded.toLowerCase()) > -1).map((holder: ISimpleHolder, i: number) => {
                                        return <li key={i}>
                                            <input type="checkbox" checked={!!this.state.selectedHoldersToRemove.find((id: number) => id == holder.user_id)} onChange={(e: any) => {
                                                if (e.target.checked) {
                                                    this.setState({
                                                        selectedHoldersToRemove: [...this.state.selectedHoldersToRemove, holder.user_id]
                                                    });
                                                } else {
                                                    this.setState({
                                                        selectedHoldersToRemove: this.state.selectedHoldersToRemove.filter((id: number) => id != holder.user_id)
                                                    });
                                                }
                                            }} />
                                            {holder.full_name}
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="moderator">
                            <span>Модератор</span>
                            {this.state.inputs.moderators_ids.length == 0 && <div style={{ display: "flex", alignItems: "center" }}>
                                <select name={"moderator0"} value={""} onChange={(e: any) => {
                                    this.setState({
                                        inputs: {
                                            ...this.state.inputs,
                                            moderators_ids: [e.target.value]
                                        }
                                    })
                                }}>
                                    <option value="">Выберите сотрудника...</option>
                                    {this.state.moderators.map((moderator: ISimpleHolder, i: number) => {
                                        return <option value={moderator.user_id} key={i}>{moderator.full_name}</option>;
                                    })}
                                </select>
                            </div>}
                            {this.state.inputs.moderators_ids.map((id: number, i: number) => {
                                return <div style={{ display: "flex", alignItems: "center" }} key={i}>
                                    <select name={"moderator" + i} value={id} onChange={(e: any) => {
                                        this.setState({
                                            inputs: {
                                                ...this.state.inputs,
                                                moderators_ids: this.state.inputs.moderators_ids.map((idd: number, ii: number) => ii == i ? e.target.value : idd)
                                            }
                                        })
                                    }}>
                                        <option value="">Выберите сотрудника...</option>
                                        {this.state.moderators.map((moderator: ISimpleHolder, i: number) => {
                                            return <option value={moderator.user_id} key={i}>{moderator.full_name}</option>;
                                        })}
                                    </select>

                                    {i != 0 && <a
                                        style={{
                                            display: "block",
                                            marginTop: "25px",
                                            marginLeft: "15px",
                                        }}
                                        role="button"
                                        onClick={() => {
                                            this.setState({
                                                inputs: {
                                                    ...this.state.inputs,
                                                    moderators_ids: this.state.inputs.moderators_ids.filter((idd: number, ii: number) => ii != i)
                                                }
                                            })
                                        }}
                                    >
                                        <img src="img/Icon ionic-md-add.png" />
                                    </a>}
                                </div>
                            })}
                            <a role="button" className="moderator-button" onClick={() => {
                                this.setState({
                                    inputs: {
                                        ...this.state.inputs,
                                        moderators_ids: [...this.state.inputs.moderators_ids, 0]
                                    }
                                })
                            }}>
                                Добавить еще
                            </a>
                            <div className="moderator-buttons">
                                <a
                                    role="button"
                                    style={{ marginTop: "0" }}
                                    className="moderator-button"
                                    onClick={() => {
                                        this.handleSubmit();
                                    }}
                                >
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-2x rotating "></i>
                                    ) : t("Сохранить")}
                                </a>
                                <a role="button" className="moderator-del" onClick={() => {
                                    this.delete();
                                }}>
                                    Удалить группу
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(withTranslation()(SingleGroup));
